import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// BENEFIT_INQUIRY_ATTACHMENT

const mutation = gql`
  mutation benefitInquiryUploadAttachment(
    $id: ID!
    $attachment: BenefitInquiryAttachmentInput!
  ) {
    benefitInquiryUploadAttachment(form_id: $id, attachment: $attachment) {
      id
      form_attachment {
        id
      }
    }
  }
`
export default function useBenefitInquiryUploadAttachment() {
  const { onMutate: onBenefitInquiryAttachmentUpload, loading } =
    useSafeRunMutation({
      mutation,
      responsePath: 'benefitInquiryUploadAttachment',
      successMessage: 'Attachment uploaded'
    })

  return { onBenefitInquiryAttachmentUpload, loading }
}
